/* ══════════════════════════════════════════════════════════════
   Pokémon Megamenu — accordion toggles
   Scoped to .nav-item--pokemon-mega only.
   New file — does not touch any existing theme JS.
   ══════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var SCOPE = '.nav-item--pokemon-mega';

  function init() {
    var container = document.querySelector(SCOPE);
    if (!container) return;

    container.querySelectorAll('.mega-pkmn__acc-toggle').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        btn.classList.toggle('expanded');
        var list = btn.nextElementSibling;
        if (list) list.classList.toggle('mega-pkmn__show');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
